<template lang="pug">
.notification
  .notification__head.font-bold
    slot(name='title')
  .notification__content
    .notification__content__title(v-for='notification in displayNotifications')
      link-base.notification__content__title__link(@click='notificationEvent(notification)') {{ notification.title }}
  .notification__toggle(v-if='showToggle')
    fa-icon.notification__toggle__icon(:icon='toggleIcon', @click='changeToggle')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import LinkBase from '@/components/atoms/LinkBase.vue'
import { NotificationItem } from '@/models/notificationModel'

/**
 * お知らせ一覧
 */
@Component({
  components: {
    LinkBase,
  },
})
export default class Notification extends Vue {
  // お知らせ一覧
  @Prop()
  notifications!: NotificationItem[]

  // お知らせリンク押下時のイベント
  @Prop()
  notificationEvent!: Function

  // お知らせの初期表示上限
  @Prop()
  initialDisplayLimit!: number

  private isOpened = false

  private get showToggle() {
    return this.notifications.length > this.initialDisplayLimit
  }

  private get displayNotifications(): NotificationItem[] {
    return this.isOpened ? this.notifications : this.notifications.slice(0, this.initialDisplayLimit)
  }

  private get toggleIcon() {
    return this.isOpened ? 'angle-up' : 'angle-down'
  }

  private changeToggle() {
    this.isOpened = !this.isOpened
  }
}
</script>

<style lang="stylus" scoped>
.notification
  position relative
  width 100%
  background-color var(--color-notification__background)
  border 2px solid var(--color-notification__border)
  &__head
    display flex
    justify-content center
    padding 0 10px
    background-color var(--color-notification__border)
    color var(--color-notification-header__text)
  &__content
    padding 10px
    &__title
      margin-bottom 5px
      &__link
        color var(--color-notification__text)
  &__toggle
    position absolute
    bottom 0
    left calc(50% - 20px)
    &__icon
      cursor pointer
      width 30px
      height 24px
</style>
